const FRAME_WIDTH = 375;
const FRAME_HEIGHT = 812;
const FRAME_TOP_DIFFERENCE = 110;
const FRRAME_BOTTOM_DIFFERENCE = 35;
const MAIN_STAGE_HEIGHT = FRAME_HEIGHT - FRAME_TOP_DIFFERENCE - FRRAME_BOTTOM_DIFFERENCE;
const BIRD_START_X = 140;
const BIRD_START_Y = MAIN_STAGE_HEIGHT / 6 + FRAME_TOP_DIFFERENCE;

export default {
  FRAME_WIDTH,
  FRAME_HEIGHT,
  FRAME_TOP_DIFFERENCE,
  FRRAME_BOTTOM_DIFFERENCE,
  MAIN_STAGE_HEIGHT,
  BIRD_START_X,
  BIRD_START_Y,
};
